import * as z from "zod"
import { WeightUnit, DimensionUnit, CargoCoolingRange, CargoCooling, CargoType, CargoTypeSub, FreightServiceAddOn, FreightService, PackingGroup, AircraftRestriction, PackingInstruction, Section, BatteryType, AircraftType, RequestStatus, ShipmentStatus, PaymentStatus, FreightStatus } from "@prisma/client"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const RequestModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  /**
   * [Address]
   */
  cargo_origin: jsonSchema,
  arrive_by: z.date().nullish(),
  dropoff_by: z.date().nullish(),
  confirmed_at: z.date().nullish(),
  gross_weight: z.number().nullish(),
  chargeable_weight: z.number().nullish(),
  volumetric_weight: z.number().nullish(),
  cargo_volume: z.number().nullish(),
  additional_information: z.string().nullish(),
  requires_direct_flight: z.boolean().nullish(),
  account_ref: z.string().nullish(),
  service_type: z.string().array(),
  is_pre_screened: z.boolean().nullish(),
  is_known_shipper: z.boolean().nullish(),
  original_weight_unit: z.nativeEnum(WeightUnit),
  original_dimension_unit: z.nativeEnum(DimensionUnit),
  cargo_details: z.string().nullish(),
  cargo_cooling_range: z.nativeEnum(CargoCoolingRange).nullish(),
  cargo_cooling: z.nativeEnum(CargoCooling).nullish(),
  cargo_type: z.nativeEnum(CargoType).nullish(),
  cargo_type_sub: z.nativeEnum(CargoTypeSub).nullish(),
  commodity: z.string().nullish(),
  target_rate: z.number().int().nullish(),
  freight_service_add_ons: z.nativeEnum(FreightServiceAddOn).array(),
  freight_services: z.nativeEnum(FreightService).array(),
  un_number: z.string().nullish(),
  class: z.string().nullish(),
  packing_group: z.nativeEnum(PackingGroup).nullish(),
  aircraft_restriction: z.nativeEnum(AircraftRestriction).nullish(),
  packing_instruction: z.nativeEnum(PackingInstruction).nullish(),
  section: z.nativeEnum(Section).nullish(),
  battery_type: z.nativeEnum(BatteryType).nullish(),
  hs_code: z.string().nullish(),
  is_military_related: z.boolean().nullish(),
  is_consolidated: z.boolean(),
  aircraft_types: z.nativeEnum(AircraftType).array(),
  customer_ref: z.string().nullish(),
  status: z.nativeEnum(RequestStatus),
  shipment_status: z.nativeEnum(ShipmentStatus).nullish(),
  payment_status: z.nativeEnum(PaymentStatus).nullish(),
  status_last_updated_at: z.date().nullish(),
  freight_status: z.nativeEnum(FreightStatus).nullish(),
  next_update_at: z.date().nullish(),
  final_update_at: z.date().nullish(),
  is_subscribed: z.boolean(),
  is_llm_generated: z.boolean().nullish(),
  account_id: z.number().int().nullish(),
  author_id: z.number().int().nullish(),
  default_sender_contact_id: z.number().int().nullish(),
  booked_quote_variant_id: z.number().int().nullish(),
  main_request_id: z.number().int().nullish(),
})
